function getErrorText(error) {
  if (!error) {
    return "Request failed. Please try again.";
  }

  if (typeof error === "string") {
    return error;
  }

  return error.message || "Request failed. Please try again.";
}

export default function ErrorAlert({ error, onRetry }) {
  return (
    <div className="alert alert-error">
      <strong>Request failed.</strong>
      <span>{getErrorText(error)}</span>
      {onRetry ? (
        <button className="btn btn-sm btn-secondary" onClick={onRetry} type="button">
          Retry
        </button>
      ) : null}
    </div>
  );
}